module.exports = __webpack_public_path__ + "static/olayemi-96d946215c9d9486fd06883387f972d3.png";